module.exports = __webpack_public_path__ + "static/media/password_icon.224f03eb.svg";